exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-right-slim {\n  margin-right: 6px;\n}\n\n.margin-right-xs {\n  margin-right: 3px;\n}\n\n.form-control.ng-valid[required] {\n  border-left: 5px solid #42A948;\n}\n\n.form-control.ng-invalid.ng-dirty,\n.form-control.ng-invalid.ng-touched {\n  border-left: 5px solid #a94442;\n}\n\n.list-group-item.striped:nth-child(odd) {\n  background-color: #f9f9f9;;\n}\n\n.no-resize {\n  resize: none;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.line-height-md {\n  height: 34px;\n  line-height: 34px;\n}\n\n.clear {\n  background-color: rgba(0, 0, 0, 0);\n  border: 1px solid rgba(0, 0, 0, 0);\n  box-shadow: none\n}\n\n.clear:hover, .clear:focus {\n  background-color: rgba(0, 0, 0, 0);\n  border: 1px solid #ccc;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\n}\n\n.textarea-high {\n  height: 75px;\n}\n\n.text-sm {\n  line-height: 20px;\n  font-size: 80%\n}\n\n.width-full {\n  width: 100%;\n}\n\n.rating {\n  line-height: 24px;\n  float: left;\n}\n\n.goal {\n  line-height: 24px;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/thesis/thesis-details/thesis-details.component.css
// module id = ../../../../../src/app/modules/thesis/thesis-details/thesis-details.component.css
// module chunks = main